import { z } from "zod";

import { PrototypeStateSlice } from "../prototype/interactions.ts";

import { ScreenDesignSpecification } from "./screenDesignSpecification.ts";

export const Dimensions = z.tuple([z.number(), z.number()]);
export type Dimensions = z.infer<typeof Dimensions>;

//TODO: should be used consider what terminology
//Currently the codebase uses both Screen and Wireframe which also get mixed up with Sre
//The naming convention is problematic due to the global window.screen property
//and secondly the term encompassing two wireframes and colored ui
export const Screen = z.object({
  // TODO : remove dimensions as it only causing confusion, and just use element size
  // or prevent usage of data in this structure is some other way, as it doeesn't include
  // any user edits
  dimensions: Dimensions,
  screenDesignSpecification: ScreenDesignSpecification,
  // Initial prototype state values referenced by this screen's interactions
  prototypeState: PrototypeStateSlice.optional(),
});
export type Screen = z.infer<typeof Screen>;

export const WireframeFidelity = z.enum(["lofi", "hifi", "ui"]);
export type WireframeFidelity = z.infer<typeof WireframeFidelity>;
